import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

export function useAuth() {
  const store = useAuthStore();

  useEffect(() => {
    // Fetch user on mount if we think we're authenticated but haven't loaded
    if (store.isAuthenticated && !store.user && store.isLoading) {
      store.fetchUser();
    }
  }, [store]);

  return {
    user: store.user,
    isLoading: store.isLoading,
    isAuthenticated: store.isAuthenticated,
    login: store.login,
    register: store.register,
    logout: store.logout,
    verifyEmail: store.verifyEmail,
    resendVerification: store.resendVerification,
  };
}
